import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFModalOpenSvgH5, EFModalCloseSvgH5, EFModalOpenSvgWhiteH5 } from '@/components/UI/svg/mm100';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');

export default function TextA() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [visibleObj, setVisibleObj] = useState({
        visible1: false,
        visible2: false,
        visible3: false,
    });
    const { locale } = useRouter();

    const handleChange = (key: string, value: boolean) => {
        const obj: any = { ...visibleObj };
        obj[key] = value;
        setVisibleObj(obj);
    };

    const imgLocale = getImageLocal(locale, ['au', 'cn', 'za']);

    return (
        <div className={`${css.LFPBatteries} LFPBatteries`}>
            <div className="texta-title-a1">{t('presale.product.modals.LFPBatteries_title1')}</div>
            <div className="texta-title-a2">{t('presale.product.modals.LFPBatteries_title2')}</div>
            <div>
                <div className="img-content img-content1" style={{ display: !visibleObj.visible1 ? 'block' : 'none' }}>
                    <EFPic name={['LFPBatteries1.webp', 'LFPBatteries1.png']} className="fullImgs" alt={t('presale.product.modals.LFPBatteries_ms1')} />
                    <div className="texta-tips">{t('presale.product.modals.LFPBatteries_ms1')}</div>
                    <EFModalOpenSvgH5
                        width="0.22rem"
                        height="0.22rem"
                        className="open-svg"
                        style={{ display: !['jp', 'kr'].includes(locale) ? 'block' : 'none' }}
                        onClick={() => handleChange('visible1', true)}
                    />
                </div>
                <div className="open-modal" style={{ display: visibleObj.visible1 ? 'flex' : 'none' }}>
                    <div className="v-msg">{t('presale.product.modals.LFPBatteries_ms4')}</div>
                    <div className="v-msg__desc">{t('presale.product.modals.LFPBatteries_ms4_desc')}</div>
                    <div className="close-svg">
                        <EFModalCloseSvgH5 width="0.31rem" height="0.31rem" onClick={() => handleChange('visible1', false)} />
                    </div>
                </div>
            </div>
            <div>
                <div className="img-content img-content2" style={{ display: !visibleObj.visible2 ? 'flex' : 'none' }}>
                    <EFPic name={['LFPBatteries2.webp', 'LFPBatteries2.png']} className="fullImgs" alt={t('presale.product.modals.LFPBatteries_ms2')} />
                    <div className="texta-tips">{t('presale.product.modals.LFPBatteries_ms2')}</div>
                    <EFModalOpenSvgWhiteH5
                        width="0.22rem"
                        height="0.22rem"
                        className="open-svg"
                        onClick={() => handleChange('visible2', true)}
                        style={{ display: !['jp', 'kr'].includes(locale) ? 'block' : 'none' }}
                    />
                </div>
                <div className="open-modal modal-2" style={{ display: visibleObj.visible2 ? 'flex' : 'none' }}>
                    <div className="v-msg">{t('presale.product.modals.LFPBatteries_ms5')}</div>
                    <div className="v-msg__desc">{t('presale.product.modals.LFPBatteries_ms5_desc')}</div>
                    <div className="close-svg">
                        <EFModalCloseSvgH5 width="0.31rem" height="0.31rem" onClick={() => handleChange('visible2', false)} />
                    </div>
                </div>
            </div>
            <div>
                <div className="img-content img-content3" style={{ display: !visibleObj.visible3 ? 'flex' : 'none' }}>
                    <EFPic
                        name={[`LFPBatteries3_${imgLocale}.webp`, `LFPBatteries3_${imgLocale}.png`]}
                        className="fullImgs"
                        alt={t('presale.product.modals.LFPBatteries_ms3')}
                    />
                    <div className="texta-tips">{t('presale.product.modals.LFPBatteries_ms3')}</div>
                    <EFModalOpenSvgH5
                        width="0.22rem"
                        height="0.22rem"
                        className="open-svg"
                        onClick={() => handleChange('visible3', true)}
                        style={{ display: !['jp', 'kr'].includes(locale) ? 'block' : 'none' }}
                    />
                </div>
                <div className="open-modal modal-3" style={{ display: visibleObj.visible3 ? 'flex' : 'none' }}>
                    <div className="v-msg">{t('presale.product.modals.LFPBatteries_ms6')}</div>
                    <div className="v-msg__desc">{t('presale.product.modals.LFPBatteries_ms6_desc')}</div>
                    <div className="close-svg">
                        <EFModalCloseSvgH5 width="0.31rem" height="0.31rem" onClick={() => handleChange('visible3', false)} />
                    </div>
                </div>
            </div>
        </div>
    );
}
